// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as FuturePromise from "rescript-future/src/FuturePromise.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as JsxRuntime from "react/jsx-runtime";
import * as CatalogCategoryPicker from "./CatalogCategoryPicker.res.js";
import * as ApolloClient__React_Hooks_UseMutation from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseMutation.res.js";

let Raw = {};

let query = Client.gql(["mutation UpdateProductCategory($id: ID!, $input: InputUpdateProductCategory!)  {\nupdateProductCategory(id: $id, input: $input)  {\n__typename  \nid  \nvariants  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nformattedCategory  \nproduct  {\n__typename  \nid  \n}\n\n}\n\n}\n\n}\n\ncategory  {\n__typename  \nid  \nformattedName  \n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.updateProductCategory;
  let value$2 = value$1.variants;
  let value$3 = value$2.edges;
  let value$4 = value$1.category;
  return {
    updateProductCategory: {
      __typename: value$1.__typename,
      id: value$1.id,
      variants: {
        __typename: value$2.__typename,
        edges: value$3.map(value => {
          let value$1 = value.node;
          let value$2 = value$1.formattedCategory;
          let value$3 = value$1.product;
          return {
            __typename: value.__typename,
            node: {
              __typename: value$1.__typename,
              id: value$1.id,
              formattedCategory: !(value$2 == null) ? value$2 : undefined,
              product: {
                __typename: value$3.__typename,
                id: value$3.id
              }
            }
          };
        })
      },
      category: !(value$4 == null) ? ({
          __typename: value$4.__typename,
          id: value$4.id,
          formattedName: value$4.formattedName
        }) : undefined
    }
  };
}

function serialize(value) {
  let value$1 = value.updateProductCategory;
  let value$2 = value$1.category;
  let category;
  if (value$2 !== undefined) {
    let value$3 = value$2.formattedName;
    let value$4 = value$2.id;
    let value$5 = value$2.__typename;
    category = {
      __typename: value$5,
      id: value$4,
      formattedName: value$3
    };
  } else {
    category = null;
  }
  let value$6 = value$1.variants;
  let value$7 = value$6.edges;
  let edges = value$7.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.product;
    let value$3 = value$2.id;
    let value$4 = value$2.__typename;
    let product = {
      __typename: value$4,
      id: value$3
    };
    let value$5 = value$1.formattedCategory;
    let formattedCategory = value$5 !== undefined ? value$5 : null;
    let value$6 = value$1.id;
    let value$7 = value$1.__typename;
    let node = {
      __typename: value$7,
      id: value$6,
      formattedCategory: formattedCategory,
      product: product
    };
    let value$8 = value.__typename;
    return {
      __typename: value$8,
      node: node
    };
  });
  let value$8 = value$6.__typename;
  let variants = {
    __typename: value$8,
    edges: edges
  };
  let value$9 = value$1.id;
  let value$10 = value$1.__typename;
  let updateProductCategory = {
    __typename: value$10,
    id: value$9,
    variants: variants,
    category: category
  };
  return {
    updateProductCategory: updateProductCategory
  };
}

function serializeInputObjectInputUpdateProductCategory(inp) {
  let a = inp.categoryId;
  return {
    categoryId: a !== undefined ? a : undefined
  };
}

function serializeVariables(inp) {
  return {
    id: inp.id,
    input: serializeInputObjectInputUpdateProductCategory(inp.input)
  };
}

function makeVariables(id, input, param) {
  return {
    id: id,
    input: input
  };
}

function makeInputObjectInputUpdateProductCategory(categoryId, param) {
  return {
    categoryId: categoryId
  };
}

let UpdateProductCategoryMutation_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputUpdateProductCategory: serializeInputObjectInputUpdateProductCategory,
  makeVariables: makeVariables,
  makeInputObjectInputUpdateProductCategory: makeInputObjectInputUpdateProductCategory
};

let include = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let UpdateProductCategoryMutation_useWithVariables = include.useWithVariables;

let UpdateProductCategoryMutation = {
  UpdateProductCategoryMutation_inner: UpdateProductCategoryMutation_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputUpdateProductCategory: serializeInputObjectInputUpdateProductCategory,
  makeVariables: makeVariables,
  makeInputObjectInputUpdateProductCategory: makeInputObjectInputUpdateProductCategory,
  use: use,
  useWithVariables: UpdateProductCategoryMutation_useWithVariables
};

function CatalogCategoryEditCell(props) {
  let productId = props.productId;
  let __compact = props.compact;
  let __variation = props.variation;
  let variation = __variation !== undefined ? __variation : "normal";
  let compact = __compact !== undefined ? __compact : false;
  let mutate = use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)[0];
  let match = React.useState(() => {});
  let setOptimisticValue = match[1];
  let match$1 = React.useState(() => false);
  let setErrored = match$1[1];
  let onMutateCategoryRequested = React.useCallback(category => {
    let tmp;
    tmp = typeof category !== "object" ? null : category._0.id;
    Future.get(FuturePromise.fromPromise(mutate(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
      id: productId,
      input: {
        categoryId: tmp
      }
    })), response => {
      if (response.TAG === "Ok" && response._0.TAG === "Ok") {
        return setErrored(param => false);
      }
      setErrored(param => true);
      setOptimisticValue(param => {});
    });
  }, []);
  let onChange = category => {
    setOptimisticValue(param => {
      if (typeof category !== "object") {
        return I18n.t("Not classified");
      } else {
        return category._0.formattedName;
      }
    });
    onMutateCategoryRequested(category);
  };
  let value = Stdlib_Option.getOr(match[0], props.value);
  let variation$1 = value === I18n.t("Not classified") ? "subdued" : variation;
  return JsxRuntime.jsx(CatalogCategoryPicker.make, {
    variation: variation$1,
    compact: compact,
    value: value,
    shopId: props.shopId,
    errored: match$1[0],
    onChange: onChange
  });
}

let make = React.memo(CatalogCategoryEditCell);

export {
  UpdateProductCategoryMutation,
  make,
}
/* query Not a pure module */
